module.exports = __webpack_public_path__ + "img/icon06.c7dbda1d.png";